import React from "react";
import { PublicFormApp } from "nextGenApp/exposed";
import MFEContainer from "assets/js/components/MFEContainer";

export function PublicForm() {
	return <MFEContainer className="publicFormContainer">
		<PublicFormApp />
	</MFEContainer>;
}

export default PublicForm;
